import { makePropCacheMixin } from '../utils/cache';
export default makePropCacheMixin('$attrs', 'bvAttrs');


// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/esm/mixins/attrs.js